import { defineStore } from 'pinia';
import { UserInfo } from '@/types';
import { postSignin } from '@/utils/user-api';
import { 
  getUser, 
  getToken, 
  setToken, 
  setUser, 
  cleanSession 
} from '@/utils/app-util';
import { User } from '@/types';

export interface SessionState {
  callingAPI: boolean;
  searching: string;
  loggedUser: User;
  token: string;
  userInfo: UserInfo;
}

export const useSessionStore = defineStore('session', {
  state: (): SessionState => ({
    callingAPI: false,
    searching: '',
    loggedUser: getUser(),
    token: getToken(),
    userInfo: {} as UserInfo,
  }),

  getters: {
    isSignedIn: (state): boolean => {
      return !!state.loggedUser?.email && !!state.token;
    },
    
    userRoles: (state): string[] => {
      return state.loggedUser?.roles || [];
    },
  },

  actions: {
    loginLoading() {
      this.callingAPI = !this.callingAPI;
    },
    
    globalSearching() {
      this.searching = this.searching === '' ? 'loading' : '';
    },
    
    setLoggedUser(user: User) {
      this.loggedUser = user;
    },
    
    setToken(_token: string) {
      this.token = _token;
    },
    
    setUserInfo(_userInfo: UserInfo) {
      this.userInfo = _userInfo;
    },
    
    // Async actions
    async signIn(userInfo: { username: string; password: string }) {
      const { username, password } = userInfo;
      
      try {
        this.callingAPI = true;
        const jwtResponse = await postSignin(userInfo);
        
        if (jwtResponse?.accessToken) {
          setToken(jwtResponse.accessToken);
          
          const user: User = {
            id: jwtResponse.id,
            username: jwtResponse.username,
            email: jwtResponse.email,
            technical: jwtResponse.technical,
            roles: jwtResponse.roles || [],
          };

          const uu = JSON.stringify(user);
          console.log("Sign User: ", uu);
          
          setUser(JSON.stringify(user));
          
          this.setToken(jwtResponse.accessToken);
          this.setLoggedUser(user);
          
          return { success: true, data: jwtResponse };
        }
      } catch (error) {
        console.error('Login error:', error);
        return { success: false, error };
      } finally {
        this.callingAPI = false;
      }
    },
    
    logout() {
      this.setToken('');
      this.setLoggedUser({} as User);
      cleanSession();
    },
    
    // You can also write actions without mutation-style methods
    async updateUserInfo(info: Partial<UserInfo>) {
      this.userInfo = { ...this.userInfo, ...info };
      // You could add API call here if needed
    },
  },
});